/********************************************************************
 * Copyright (c) Certus Software, 2022.                             *
 *                                                                  *
 * This unpublished material is proprietary to Certus Software.     *
 * All rights reserved. The methods and techniques described        *
 * herein are considered confidential and/or trade secrets.         *
 * Reproduction or distribution, in whole or in part, is forbidden  *
 * except by express written permission of Certus Software.         *
 ********************************************************************/

import {Component, Input, OnInit} from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'guide-pagination',
  templateUrl: './guide-pagination.component.html',
  styleUrls: ['./guide-pagination.component.scss']
})
export class GuidePaginationComponent implements OnInit {

  @Input() previousText: string;
  @Input() previousChapterText: string;
  @Input() previousRoute: string;
  @Input() nextText: string;
  @Input() nextChapterText: string;
  @Input() nextRoute: string;

  constructor() { }

  ngOnInit(): void {
  }

}
